import styled from 'styled-components';

export const Plate = styled.div`
  border-radius: 20px;
  background: #fff;
  &:hover {
    box-shadow: 0px 12px 24px 0px rgba(57, 78, 127, 0.2);
  }
  display: flex;
  flex-direction: column;
  padding: 23px;
`;

export const Title = styled.span`
  color: rgba(9, 21, 38, 0.85);
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 28.8px */
  letter-spacing: -0.24px;
  display: block;
`;

export const Text = styled.span`
  color: rgba(9, 21, 38, 0.85);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 137.5% */
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
